import React from 'react'
import { BrowserRouter } from "react-router-dom"
import { AuthRoutes } from 'AuthRoutes';
import { ProtectedRoutes } from 'ProtectedRoutes';
import { useSelector } from 'react-redux';
import { userSelector } from 'slices/userSlice';

export const AppRoutes = () => {
  const { isAuthenticated, user } = useSelector(userSelector);

  return (
    <BrowserRouter>
      {/* Public and Auth Routes */}

      {/* Protected Routes */}
      {isAuthenticated ?
        <ProtectedRoutes />
        :
        <AuthRoutes />

      }
      {/* Fallback Route */}
      {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
    </BrowserRouter>
  )
}
